import { Dropdown } from "react-bootstrap";
import "./notificationDropdown.scss";
import { useContext } from "react";
import NotificationIcon from "assets/imgs/icons/notification.svg";
import BellIcon from "assets/imgs/icons/BelliconOutlined.svg";
import { AuthContext } from "context/AuthContext";
import getNotifications from "service/shared/get-notifications";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import updateNotification from "service/shared/update-notification";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import NotificationsHeader from "assets/imgs/icons/notifications_header.svg";
import Tooltip from "react-bootstrap/Tooltip";
import { useState } from "react";

function NotificationDropdown() {
  const { authState } = useContext(AuthContext);
  const [newNotification, setNewNotification] = useState(false);
  const { isLoading, data = [] } = useQuery(
    ["notifications", authState?.userInfo?.cifNumber],
    () => getNotifications(authState?.userInfo?.cifNumber),
    {
      enabled: !!authState?.userInfo?.cifNumber,
    }
  );
  const { mutate } = useMutation(updateNotification);
  const queryClient = useQueryClient();

  const renderTooltip = (props) => (
    <Tooltip id="header-tooltip">{props}</Tooltip>
  );

  return (
    <div className="cursor-pointer position-relative notificationDropdown__notification">
      <Dropdown id="dropdown-notification">
        <Dropdown.Toggle as="div" variant="success" id="dropdown-notification">
          <OverlayTrigger
            placement="top"
            overlay={renderTooltip("Notifications")}
          >
            <div className={`${newNotification ? "new-notification" : ""}`}>
              <img
                className="cursor-pointer cif__settings-icon mx-2"
                src={NotificationsHeader}
                alt=""
              />
            </div>
          </OverlayTrigger>
        </Dropdown.Toggle>

        <Dropdown.Menu
          style={{ maxHeight: "15rem" }}
          className=""
          id="dropdown-notification"
        >
          {data.length > 0 && (
            <div className="d-flex align-items-center justify-content-between notificationDropdown__notification_box">
              <span>Notifications</span>
              <span
                onClick={() => {
                  for (let i = 0; i < data.length; i++) {
                    mutate(
                      {
                        cifNumber: authState?.userInfo?.cifNumber,
                        notificationId: data[i].id,
                      },
                      {
                        onSuccess: (d) =>
                          queryClient.setQueryData(
                            ["notifications", data[i].id],
                            d
                          ),
                      }
                    );
                  }
                }}
              >
                Mark all as read
              </span>
            </div>
          )}
          {data.length === 0 && (
            <div className="notificationDropdown__notification_content d-flex align-items-center justify-content-center flex-column">
              <img src={BellIcon} alt="" className="notification-bell-img" />
              <div className="font-sm mt-3">
                {isLoading ? "Checking for updates." : "No notifications yet."}
              </div>
              <div className="font-sm mt-3">
                When you get notifications, they will show up here.
              </div>
            </div>
          )}
          {data.length > 0 && (
            <div className="notificationDropdown__notification_content">
              <ul>
                {/* use the class fw-600 for unread notifications */}
                {data.map(({ id, message }, i) => (
                  <li
                    onClick={() =>
                      mutate(
                        {
                          cifNumber: authState?.userInfo?.cifNumber,
                          notificationId: id,
                        },
                        {
                          onSuccess: (d) =>
                            queryClient.setQueryData(["notifications", id], d),
                        }
                      )
                    }
                    key={i}
                  >
                    {message}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default NotificationDropdown;
